import React from 'react';

import * as S from './styles';

export function Tabs({ children }) {
  return <S.Tabs>{children}</S.Tabs>;
}

export default function Tab({ children, active, onClick, error }) {
  return (
    <S.Tab type="button" active={active} onClick={onClick} error={error}>
      {children}
    </S.Tab>
  );
}
